module.exports = __webpack_public_path__ + "static/25invgde-9687226ee9c59753034e99b68bfdb821.gif";